define.alias("ember-math-helpers/helpers/log1p", "settings/helpers/log1p");